import { Currency } from '@/core/currency/interfaces';

const COP: Currency = {
    name: 'Colombian Peso',
    demonym: 'Colombian',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '170',
    symbol: 'CO$',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'COP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default COP;
